import {
  AnimatedList,
  AnimatedListItem,
} from "@babackapp/customer-ui/components/animated-list";
import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { ImageInput } from "@babackapp/customer-ui/components/image-input";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroupTextarea,
} from "@babackapp/customer-ui/components/input-group";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/customer-ui/components/select";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { MessageCircleMoreIcon } from "lucide-react";
import { Controller } from "react-hook-form";
import { useLineItemReasonForm } from "../../hooks/use-line-item-reason-form";

export function Reason() {
  const { form, onSubmit, reasons, selectedReason } = useLineItemReasonForm();

  const showComment = !selectedReason || selectedReason.commentAvailable;
  const showImages = !selectedReason || selectedReason.photoAvailable;

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>Expliquez nous pourquoi</HeaderTitle>
        <HeaderDescription>
          Pour nous améliorer, expliquez votre choix de retourner cet article.
        </HeaderDescription>
      </Header>

      <form onSubmit={onSubmit}>
        <AnimatedList>
          <AnimatedListItem>
            <Controller
              control={form.control}
              name="reasonId"
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full h-auto py-3 text-sm">
                    <SelectValue placeholder="Sélectionnez une raison" />
                  </SelectTrigger>
                  <SelectContent>
                    {reasons.map((reason) => (
                      <SelectItem key={reason.id} value={reason.id}>
                        {reason.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
            {form.formState.errors.reasonId && (
              <p className="text-destructive text-xs mt-1">
                {form.formState.errors.reasonId.message}
              </p>
            )}
          </AnimatedListItem>

          {showComment && (
            <AnimatedListItem>
              <Controller
                control={form.control}
                name="comment"
                render={({ field }) => (
                  <InputGroup className="h-auto">
                    <InputGroupTextarea
                      placeholder={
                        selectedReason?.requiresComment
                          ? "Ajoutez un commentaire"
                          : "Ajoutez un commentaire (optionnel)"
                      }
                      value={field.value ?? ""}
                      onChange={(e) => field.onChange(e.target.value || null)}
                    />
                    <InputGroupAddon align="block-start">
                      <InputGroupText>Commentaire</InputGroupText>
                      <MessageCircleMoreIcon />
                    </InputGroupAddon>
                  </InputGroup>
                )}
              />
              {form.formState.errors.comment && (
                <p className="text-destructive text-xs mt-1">
                  {form.formState.errors.comment.message}
                </p>
              )}
            </AnimatedListItem>
          )}

          {showImages && (
            <AnimatedListItem>
              <Controller
                control={form.control}
                name="images"
                render={({ field }) => (
                  <ImageInput onChange={field.onChange} />
                )}
              />
              {form.formState.errors.images && (
                <p className="text-destructive text-xs mt-1">
                  {form.formState.errors.images.message}
                </p>
              )}
            </AnimatedListItem>
          )}
        </AnimatedList>

        <AnimatedButtonRow exit={{}}>
          <AnimatedButtonContainer
            layoutId="line-item-confirm-button"
            disableVariants={{ exit: true }}
          >
            <Button type="submit">
              <EnterIcon />
              Confirmer
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </form>
    </WidgetPage>
  );
}
